var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6L14.34 10H8C5.8 10 4 11.8 4 14V38C4 40.2 5.8 42 8 42H40C42.2 42 44 40.2 44 38V14C44 11.8 42.2 10 40 10H33.66L30 6H18ZM24 36C18.48 36 14 31.52 14 26C14 20.48 18.48 16 24 16C29.52 16 34 20.48 34 26C34 31.52 29.52 36 24 36Z",
    fill: "#9CA3AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 34L26.5 28.5L32 26L26.5 23.5L24 18L21.5 23.5L16 26L21.5 28.5L24 34Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCam);
export default __webpack_public_path__ + "static/media/cam.149968eed53272b3ea0ad3af3d1771b0.svg";
export { ForwardRef as ReactComponent };